module.exports = __webpack_public_path__ + "static/media/player_back_btn.d9b6500b.svg";